import { RootState } from 'editor/src/store/index';

const getSpreadPreview = (state: RootState) => state.editorModules.preview.spreadPreview;

export default getSpreadPreview;
